export default __webpack_public_path__ + "static/media/prestation electronique.e52cfd86.png";